import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoCheckboxComponent } from './avano-checkbox.component';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoCheckboxComponent],
  declarations: [AvanoCheckboxComponent]
})
export class AvanoCheckboxModule {}
